export default {
  'terra-cotta': '#e25d34',
  dark: '#2b3d54',
  'dark-two-opa20': 'rgba(31,43,55,0.2)',
  'dark-two': '#2b3d54',
  'dark-three': '#2b3d54',
  'dark-five': '#2b3d54',
  'dark-four': '#2b3d54',
  white: '#fff',
  'white-two': '#f5f5f5',
  'white-three': '#f7f7f7',
  'grey-two': '#e0e0e0',
  'grey-four': '#b0b0b0',
  'grey-three': '#b2c3ca',
  'grey-five': '#e8e9eb',
  'grey-opa5': 'rgba(245, 245, 245, 0.5)',
  'slate-grey': '#525d69',
  'grey-six': '#ebecee',
  steel: '#7b838b',
  'cool-grey': '#a4abae',
  silver: '#d0d4d3'
};
